// eslint-disable-next-line no-unused-vars
import React from 'react';
import { func } from 'prop-types';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Megaphone } from 'lucide-react';

const StyledContainer = styled.div`
  width: 280px;
  max-width: 100%;

  @media screen and (max-width: 767px) {
    width: 100%;
  }

  .nodStockAlertLink {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    min-height: 50px;
    padding: 10px 16px;
    border: 1px solid currentColor;
    background: transparent;
    color: ${ props => props.theme.colors?.default || '#0f2a53' };
    font: inherit;
    font-size: 1rem;
    cursor: pointer;

    svg {
      flex: 0 0 16px;
      width: 16px;
      height: 16px;
    }

    &:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 3px;
    }
  }
`;

const NodStockAlert = ({ onOpen }) => {
  const { t } = useTranslation();

  return (
    <StyledContainer data-test="nodStockAlert">
      <button type="button" className="nodStockAlertLink" onClick={ onOpen }>
        <Megaphone size={ 16 } aria-hidden="true" />
        <span>{ t('products.nodStockAlert') }</span>
      </button>
    </StyledContainer>
  );
};

NodStockAlert.propTypes = {
  onOpen: func.isRequired
};

export default NodStockAlert;
